import React, { useState } from 'react';
import CreditCardList from '../components/CreditCardList';
import CreditCardForm from '../components/CreditCardForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';

function CreditCardsPage() {
  const [editingCreditCard, setEditingCreditCard] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const width = useWindowWidth();

  const handleEdit = (card) => {
    setEditingCreditCard(card);
    setShowForm(true);
  };

  const handleNewCreditCard = () => {
    setEditingCreditCard(null);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingCreditCard(null);
    // Optionally, refresh the credit card list here if it's not handled by a global state
  };

  const isDesktop = width >= 768;

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && !showForm && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Cartões de Crédito</h1>
            <p>Gerencie seus cartões de crédito</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewCreditCard}>
            + Novo Cartão
          </button>
        </div>
      )}

      {/* ── Mobile header (mantido exatamente como era) ── */}
      {!isDesktop && <h1>Gerenciamento de Cartões de Crédito</h1>}
      {!isDesktop && !showForm && (
        <button className="btn btn-success mb-3" onClick={handleNewCreditCard}>Adicionar Novo Cartão de Crédito</button>
      )}

      {showForm ? (
        <div>
          {isDesktop
            ? <p className="rv-form-heading">{editingCreditCard ? 'Editar Cartão de Crédito' : 'Novo Cartão de Crédito'}</p>
            : <h2>{editingCreditCard ? 'Editar Cartão de Crédito' : 'Criar Novo Cartão de Crédito'}</h2>
          }
          <CreditCardForm creditCard={editingCreditCard} onSuccess={handleSuccess} />
          <button className="btn btn-secondary mt-3" onClick={() => setShowForm(false)}>Cancelar</button>
        </div>
      ) : (
        <CreditCardList onEdit={handleEdit} />
      )}
    </div>
  );
}

export default CreditCardsPage;
